import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=fe9d53c8&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=ts&"
export * from "./LicenseList.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseList.vue?vue&type=style&index=0&id=fe9d53c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9d53c8",
  null
  
)

export default component.exports